import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, InvalidateLevel, SuitableMaterials } from '@types';
import { appActions } from '../app';
import { selectIsPollingSuitableMaterialsActive, selectModelsIdsForSuitableMaterials } from './selectors';

interface State {
    data: Record<string, SuitableMaterials>;
    isPollingActive: boolean;
}

const initialState: State = {
    data: {},
    isPollingActive: false,
};

export const suitableMaterialsSlice = createSlice({
    name: 'suitableMaterials',
    initialState,
    reducers: {
        pollingStarted: state => {
            state.isPollingActive = true;
        },
        pollingStopped: state => {
            state.isPollingActive = false;
        },

        load: (state, action: PayloadAction<number[]>) => {},
        loadSuccess: (state, action: PayloadAction<Record<string, SuitableMaterials>>) => {
            state.data = {
                ...state.data,
                ...action.payload,
            };
        },
        loadFailure: state => {},
        readyReceived: (state, action: PayloadAction<Array<[string, SuitableMaterials]>>) => {},
    },
    extraReducers: builder => {
        builder.addCase(appActions.invalidateStore, (state, { payload }) =>
            payload.purge >= InvalidateLevel.Models ? { ...initialState } : state,
        );
    },
});

export const suitableMaterialsActions = suitableMaterialsSlice.actions;

export const startSuitableMaterialsPolling = (): AppThunk => (dispatch, getState) => {
    const state = getState();
    const isActive = selectIsPollingSuitableMaterialsActive(state);
    const ids = selectModelsIdsForSuitableMaterials(state);

    if (isActive || !ids.length) return;

    dispatch(suitableMaterialsActions.pollingStarted());
};
